import { eTipoPermissao } from '@/enums/ePermissoes';

// Módulo "Estudantes com PDI" — anamnese por estudante (Subsistema B: raiz PDIAluno, irmãos e as
// respostas do questionário do molde por etapa). Menu único (como o Res. 4256): a busca do
// estudante e o workspace resolvem tudo dentro desta rota. A sigla no título é a nomenclatura
// configurável (token {pdiSigla}, padrão "PDI"), resolvida pelo pdinomenclatura.service.
export default [
  {
    description: 'Estudantes com {pdiSigla}',
    path: '/educacaoinclusiva/pdi-anamnese',
    name: 'pdi_anamnese',
    component: () => import('@/views/educacaoinclusiva/pdi-anamnese/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.NOVO_PDI_ANAMNESE_2300100151],
    },
    goesToMenu: true,
  },
];
